import React, { useState, useEffect, useMemo } from 'react'
import axios from "axios"
import { Link } from "react-router-dom"
import { TanggalHari } from '../Utils'
import Pagination from '../pages/paginations'

const View = ({ kategori }) => {
    const [currentPage, setCurrentPage] = useState(1)
    const [PageSize] = useState(10)
    const [data, setData] = useState([])

    useEffect(() => {
        getData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const getData = async (val) => {
        const category = kategori.replaceAll('-', ' ').toUpperCase()
        const response = await axios.post("/api/publikasi/publish", {
            keyword: val || '',
            kategori: category,
            jml: 100
        })
        setData(response.data)
        setCurrentPage(1)
    }

    const batasiKata = (teks, jumlahKata = 10) => {
        return teks.split(" ").slice(0, jumlahKata).join(" ") + (teks.split(" ").length > jumlahKata ? "..." : "")
    }

    const tableData = useMemo(() => {
        const firstPageIndex = (currentPage - 1) * PageSize
        const lastPageIndex = firstPageIndex + PageSize
        return !data ? [] : data.slice(firstPageIndex, lastPageIndex)
    }, [data, currentPage])

    return (<>
        <div className="row">
            <div className="col-md-12">
                <input type="text" className="form-control" placeholder="Masukkan Kata Kunci" onChange={(e) => getData(e.target.value)} />
            </div>
        </div>
        <div className="row">
            {tableData.map((val, index) => (
                <div className="col-md-6 mb-4" key={index}>
                    <Link to={'/info/agenda-kegiatan/' + val.title} className="panel panel-dark panel-primary">
                        <div className="panel-heading">
                            <h3 className='panel-title'>{batasiKata(val.judul, 5)}</h3>
                        </div>
                        <div className="panel-body">
                            <TanggalHari value={val.tanggal} />
                        </div>
                    </Link>
                </div>
            ))}
        </div>
        <div className="text-center p-4">
            <Pagination className="pagination-bar" currentPage={currentPage} totalCount={data.length} pageSize={PageSize} onPageChange={page => setCurrentPage(page)} />
        </div>
    </>)
}

export default View;